// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    background-color: white;
}

body {
    font-family: "Poppins", sans-serif;
    height: 100vh;
}

a {
    color: #0d0d0d;
    display: block;
    text-decoration: none;
    font-weight: 400;
    margin: 45px 0 20px;
}

a:hover {
    text-decoration: none;
    color: #92badd;
}

h2 {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    display: inline-block;
    margin: 20px 8px 10px 8px;
    color: #cccccc;
}



/* STRUCTURE */

.wrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100vh;
    padding: 20px;
}

#formContent {
    border-radius: 10px 10px 10px 10px;
    background: #fff;
    padding: 30px;
    width: 90%;
    max-width: 450px;
    position: relative;
    padding: 0px;
    box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
    text-align: center;
}

#formFooter {
    background-color: #f6f6f6;
    border-top: 1px solid #dce8f1;
    padding: 25px;
    text-align: center;
    border-radius: 0 0 10px 10px;
}



/* TABS */

h2.inactive {
    color: #cccccc;
}

h2.active {
    color: #0d0d0d;
    border-bottom: 2px solid #5fbae9;
}



/* FORM TYPOGRAPHY*/

input[type=button],
input[type=submit],
input[type=reset] {
    background-color: #56baed;
    border: none;
    color: white;
    padding: 15px 80px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    text-transform: uppercase;
    font-size: 13px;
    box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
    border-radius: 5px 5px 5px 5px;
    margin: 5px 20px 40px 20px;
    transition: all 0.3s ease-in-out;
}

input[type=button]:hover,
input[type=submit]:hover,
input[type=reset]:hover {
    background-color: #39ace7;
}

input[type=button]:active,
input[type=submit]:active,
input[type=reset]:active {
    transform: scale(0.95);
}

input[type=text],
input[type=password],
input[type=email] {
    background-color: #f6f6f6;
    border: none;
    color: #0d0d0d;
    padding: 15px 32px;
    text-align: left;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 5px;
    width: 95%;
    border: 2px solid #f6f6f6;
    transition: all 0.5s ease-in-out;
    border-radius: 5px 5px 5px 5px;
}

input[type=checkbox] {
    margin-left: 10px;
    font-weight: 200;
}

input[type=text]:focus,
input[type=password]:focus,
input[type=email]:focus {
    background-color: #fff;
    border-bottom: 2px solid #5fbae9;
}

input[type=text]::placeholder,
input[type=password]::placeholder,
input[type=email]::placeholder {
    color: #cccccc;
}



/* ANIMATIONS */

/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
    animation-name: fadeInDown;
    animation-duration: 1s;
    animation-fill-mode: both;
}

@keyframes fadeInDown {
    0% {
        opacity: 0;
        transform: translate3d(0, -100%, 0);
    }

    100% {
        opacity: 1;
        transform: none;
    }
}

/* Simple CSS3 Fade-in Animation */

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.fadeIn {
    opacity: 0;
    animation: fadeIn ease-in 1;
    animation-fill-mode: forwards;
    animation-duration: 1s;
}

.fadeIn.first {
    animation-delay: 0.4s;
}

.fadeIn.second {
    animation-delay: 0.6s;
}

.fadeIn.third {
    animation-delay: 0.8s;
}

.fadeIn.fourth {
    animation-delay: 1s;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
    display: block;
    left: 0;
    bottom: -10px;
    width: 0;
    height: 2px;
    background-color: #56baed;
    content: "";
    transition: width 0.2s;
}

.underlineHover:hover {
    color: #0d0d0d;
}

.underlineHover:hover:after {
    width: 100%;
}



/* OTHERS */

*:focus {
    outline: none;
}

#icon {
    width: 60%;
}

label {
    margin-right: 300px;
    font-size: 18px;
    font-weight: 500;
}

#hidePassword {
    background-color: #f6f6f6;
    border: none;
    color: #0d0d0d;
    padding: 15px 32px;
    text-align: left;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 5px;
    width: 85%;
    border: 2px solid #f6f6f6;
    transition: all 0.5s ease-in-out;
    border-radius: 5px 5px 5px 5px;
}

span {
    position: absolute;
    right: 35px;
    top: 53%;
    transform: translateY(-50%);
    font-size: 20px;
    color: #cccccc;
    cursor: pointer;
    display: none;
}

input:valid~span {
    display: block;
}


span i.hide-btn::before {
    content: "f070";
}`, "",{"version":3,"sources":["webpack://./src/access/main.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;AAClB;;;;AAIA,cAAc;;AAEd;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,aAAa;AACjB;;AAEA;IAEI,kCAAkC;IAClC,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IAEZ,4CAA4C;IAC5C,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,aAAa;IACb,kBAAkB;IAElB,4BAA4B;AAChC;;;;AAIA,SAAS;;AAET;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gCAAgC;AACpC;;;;AAIA,mBAAmB;;AAEnB;;;IAGI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,yBAAyB;IACzB,eAAe;IAEf,iDAAiD;IAEjD,8BAA8B;IAC9B,0BAA0B;IAK1B,gCAAgC;AACpC;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;;;IAOI,sBAAsB;AAC1B;;AAEA;;;IAGI,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,UAAU;IACV,yBAAyB;IAKzB,gCAAgC;IAEhC,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;;IAGI,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;;;IAGI,cAAc;AAClB;;;;AAIA,eAAe;;AAEf,uCAAuC;AACvC;IAEI,0BAA0B;IAE1B,sBAAsB;IAEtB,yBAAyB;AAC7B;;AAgBA;IACI;QACI,UAAU;QAEV,mCAAmC;IACvC;;IAEA;QACI,UAAU;QAEV,eAAe;IACnB;AACJ;;AAEA,kCAAkC;;AAqBlC;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,UAAU;IAGV,2BAA2B;IAI3B,6BAA6B;IAI7B,sBAAsB;AAC1B;;AAEA;IAGI,qBAAqB;AACzB;;AAEA;IAGI,qBAAqB;AACzB;;AAEA;IAGI,qBAAqB;AACzB;;AAEA;IAGI,mBAAmB;AACvB;;AAEA,kCAAkC;AAClC;IACI,cAAc;IACd,OAAO;IACP,aAAa;IACb,QAAQ;IACR,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;;;AAIA,WAAW;;AAEX;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,UAAU;IACV,yBAAyB;IAKzB,gCAAgC;IAEhC,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,cAAc;IACd,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,eAAe;AACnB","sourcesContent":["html {\n    background-color: white;\n}\n\nbody {\n    font-family: \"Poppins\", sans-serif;\n    height: 100vh;\n}\n\na {\n    color: #0d0d0d;\n    display: block;\n    text-decoration: none;\n    font-weight: 400;\n    margin: 45px 0 20px;\n}\n\na:hover {\n    text-decoration: none;\n    color: #92badd;\n}\n\nh2 {\n    text-align: center;\n    font-size: 16px;\n    font-weight: 600;\n    text-transform: uppercase;\n    display: inline-block;\n    margin: 20px 8px 10px 8px;\n    color: #cccccc;\n}\n\n\n\n/* STRUCTURE */\n\n.wrapper {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    height: 100vh;\n    padding: 20px;\n}\n\n#formContent {\n    -webkit-border-radius: 10px 10px 10px 10px;\n    border-radius: 10px 10px 10px 10px;\n    background: #fff;\n    padding: 30px;\n    width: 90%;\n    max-width: 450px;\n    position: relative;\n    padding: 0px;\n    -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);\n    box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);\n    text-align: center;\n}\n\n#formFooter {\n    background-color: #f6f6f6;\n    border-top: 1px solid #dce8f1;\n    padding: 25px;\n    text-align: center;\n    -webkit-border-radius: 0 0 10px 10px;\n    border-radius: 0 0 10px 10px;\n}\n\n\n\n/* TABS */\n\nh2.inactive {\n    color: #cccccc;\n}\n\nh2.active {\n    color: #0d0d0d;\n    border-bottom: 2px solid #5fbae9;\n}\n\n\n\n/* FORM TYPOGRAPHY*/\n\ninput[type=button],\ninput[type=submit],\ninput[type=reset] {\n    background-color: #56baed;\n    border: none;\n    color: white;\n    padding: 15px 80px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    text-transform: uppercase;\n    font-size: 13px;\n    -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);\n    box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);\n    -webkit-border-radius: 5px 5px 5px 5px;\n    border-radius: 5px 5px 5px 5px;\n    margin: 5px 20px 40px 20px;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n\ninput[type=button]:hover,\ninput[type=submit]:hover,\ninput[type=reset]:hover {\n    background-color: #39ace7;\n}\n\ninput[type=button]:active,\ninput[type=submit]:active,\ninput[type=reset]:active {\n    -moz-transform: scale(0.95);\n    -webkit-transform: scale(0.95);\n    -o-transform: scale(0.95);\n    -ms-transform: scale(0.95);\n    transform: scale(0.95);\n}\n\ninput[type=text],\ninput[type=password],\ninput[type=email] {\n    background-color: #f6f6f6;\n    border: none;\n    color: #0d0d0d;\n    padding: 15px 32px;\n    text-align: left;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 16px;\n    margin: 5px;\n    width: 95%;\n    border: 2px solid #f6f6f6;\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n    transition: all 0.5s ease-in-out;\n    -webkit-border-radius: 5px 5px 5px 5px;\n    border-radius: 5px 5px 5px 5px;\n}\n\ninput[type=checkbox] {\n    margin-left: 10px;\n    font-weight: 200;\n}\n\ninput[type=text]:focus,\ninput[type=password]:focus,\ninput[type=email]:focus {\n    background-color: #fff;\n    border-bottom: 2px solid #5fbae9;\n}\n\ninput[type=text]::placeholder,\ninput[type=password]::placeholder,\ninput[type=email]::placeholder {\n    color: #cccccc;\n}\n\n\n\n/* ANIMATIONS */\n\n/* Simple CSS3 Fade-in-down Animation */\n.fadeInDown {\n    -webkit-animation-name: fadeInDown;\n    animation-name: fadeInDown;\n    -webkit-animation-duration: 1s;\n    animation-duration: 1s;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeInDown {\n    0% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -100%, 0);\n        transform: translate3d(0, -100%, 0);\n    }\n\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none;\n    }\n}\n\n@keyframes fadeInDown {\n    0% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -100%, 0);\n        transform: translate3d(0, -100%, 0);\n    }\n\n    100% {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none;\n    }\n}\n\n/* Simple CSS3 Fade-in Animation */\n@-webkit-keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@-moz-keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n.fadeIn {\n    opacity: 0;\n    -webkit-animation: fadeIn ease-in 1;\n    -moz-animation: fadeIn ease-in 1;\n    animation: fadeIn ease-in 1;\n\n    -webkit-animation-fill-mode: forwards;\n    -moz-animation-fill-mode: forwards;\n    animation-fill-mode: forwards;\n\n    -webkit-animation-duration: 1s;\n    -moz-animation-duration: 1s;\n    animation-duration: 1s;\n}\n\n.fadeIn.first {\n    -webkit-animation-delay: 0.4s;\n    -moz-animation-delay: 0.4s;\n    animation-delay: 0.4s;\n}\n\n.fadeIn.second {\n    -webkit-animation-delay: 0.6s;\n    -moz-animation-delay: 0.6s;\n    animation-delay: 0.6s;\n}\n\n.fadeIn.third {\n    -webkit-animation-delay: 0.8s;\n    -moz-animation-delay: 0.8s;\n    animation-delay: 0.8s;\n}\n\n.fadeIn.fourth {\n    -webkit-animation-delay: 1s;\n    -moz-animation-delay: 1s;\n    animation-delay: 1s;\n}\n\n/* Simple CSS3 Fade-in Animation */\n.underlineHover:after {\n    display: block;\n    left: 0;\n    bottom: -10px;\n    width: 0;\n    height: 2px;\n    background-color: #56baed;\n    content: \"\";\n    transition: width 0.2s;\n}\n\n.underlineHover:hover {\n    color: #0d0d0d;\n}\n\n.underlineHover:hover:after {\n    width: 100%;\n}\n\n\n\n/* OTHERS */\n\n*:focus {\n    outline: none;\n}\n\n#icon {\n    width: 60%;\n}\n\nlabel {\n    margin-right: 300px;\n    font-size: 18px;\n    font-weight: 500;\n}\n\n#hidePassword {\n    background-color: #f6f6f6;\n    border: none;\n    color: #0d0d0d;\n    padding: 15px 32px;\n    text-align: left;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 16px;\n    margin: 5px;\n    width: 85%;\n    border: 2px solid #f6f6f6;\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n    transition: all 0.5s ease-in-out;\n    -webkit-border-radius: 5px 5px 5px 5px;\n    border-radius: 5px 5px 5px 5px;\n}\n\nspan {\n    position: absolute;\n    right: 35px;\n    top: 53%;\n    transform: translateY(-50%);\n    font-size: 20px;\n    color: #cccccc;\n    cursor: pointer;\n    display: none;\n}\n\ninput:valid~span {\n    display: block;\n}\n\n\nspan i.hide-btn::before {\n    content: \"f070\";\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
